import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingFontGeneratorConfig } from '@/data/landingConfig/landingFontGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_FontGenerator } from './schemaObject';

interface Props {}
const FontGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_FontGenerator} />
			<LandingTemplate
				data={landingFontGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelFontGenerator()}
			/>
		</>
	);
};

export default FontGenerator;
